import request from '@/utils/seftRequest';

// 修改主产品属性 drm/ding/subsService/changeMainProdFeatureBsnl
export function changeMainProdFeature(data) {
  return request('/ding/subsService/changeMainProdFeatureBsnl', {
    method: 'POST',
    body: data,
  });
}
